import { useState } from 'react';
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,
  Tabs,
  Tab,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import ChatIcon from '@mui/icons-material/Chat';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector } from 'react-redux';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from '../settings/components/SettingsMenu';
import { useTranslation } from '../common/components/LocalizationProvider';
import SimpleChat from './SimpleChat';
import AssistantConfigPanel from './AssistantConfigPanel';

const useStyles = makeStyles()((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    height: 'calc(100vh - 100px)',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100% !important',
    padding: theme.spacing(0, 1),
  },
  chatContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

const TAB_CHAT = 0;
const TAB_CONFIG = 1;

const AssistantPage = () => {
  const { classes } = useStyles();
  const t = useTranslation();
  const user = useSelector((state) => state.session.user);
  const isAdmin = user?.administrator;

  const [activeTab, setActiveTab] = useState(TAB_CHAT);
  const [error, setError] = useState(null);

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'assistantTitle']}>
      <Container maxWidth={false} className={classes.container}>
        {/* Header - Only show for admin */}
        {isAdmin && (
          <Paper sx={{ mb: 1 }}>
            <Box className={classes.header}>
              <Box className={classes.headerLeft}>
                <SmartToyIcon color="primary" />
                <Typography variant="h6">
                  {t('assistantTitle') || 'Assistente IA'}
                </Typography>
              </Box>
            </Box>

            <Tabs
              value={activeTab}
              onChange={(_, value) => setActiveTab(value)}
              sx={{ borderTop: 1, borderColor: 'divider' }}
            >
              <Tab icon={<ChatIcon />} iconPosition="start" label="Chat" />
              <Tab icon={<SettingsIcon />} iconPosition="start" label="Configuração" />
            </Tabs>
          </Paper>
        )}

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 1 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Content */}
        {activeTab === TAB_CONFIG && isAdmin ? (
          <AssistantConfigPanel />
        ) : (
          <Paper className={classes.chatContainer}>
            <SimpleChat />
          </Paper>
        )}
      </Container>
    </PageLayout>
  );
};

export default AssistantPage;
